import React from "react";
import { Progress, Card, Typography, Spin } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { useAppSelector } from "@/store/hooks";
import "./index.scss";

const { Text } = Typography;

interface PdfProcessingProgressProps {
  className?: string;
}

const PdfProcessingProgress: React.FC<PdfProcessingProgressProps> = ({
  className,
}) => {
  const pdfProcessingProgress = useAppSelector(
    (state) => state.canvas.pdfProcessingProgress,
  );

  if (!pdfProcessingProgress.isProcessing) {
    return null;
  }

  const {
    currentFile,
    currentStep,
    totalFiles,
    currentFileIndex,
    totalPages,
    currentPage,
    progress,
    stats,
  } = pdfProcessingProgress;

  return (
    <Card className={`pdf-processing-progress ${className}`} size="small">
      <div className="pdf-processing-header">
        <FileTextOutlined className="pdf-icon" />
        <div className="header-content">
          <Text strong>
            Processing {totalFiles && totalFiles > 1 ? "Files" : "PDF"}
            {totalFiles &&
              totalFiles > 1 &&
              ` (${currentFileIndex || 1}/${totalFiles})`}
          </Text>
          {currentFile && (
            <Text type="secondary" className="file-name">
              {currentFile}
            </Text>
          )}
        </div>
      </div>

      <div className="pdf-processing-body">
        <Progress
          percent={progress || 0}
          status={progress === 100 ? "success" : "active"}
          strokeColor={{
            "0%": "#BDA1C9",
            "100%": "#8B5A9F",
          }}
          size="small"
        />

        <div className="pdf-processing-details">
          <div className="processing-step">
            <Spin size="small" spinning={progress !== 100} />
            <Text className="step-text">{currentStep}</Text>
          </div>

          {totalFiles && totalFiles > 1 && (
            <div className="file-info">
              <Text type="secondary" size="small">
                File {currentFileIndex || 1} of {totalFiles}
              </Text>
            </div>
          )}

          {totalPages && (
            <div className="page-info">
              <Text type="secondary" size="small">
                {currentPage
                  ? `Page ${currentPage} of ${totalPages}`
                  : `Total pages: ${totalPages}`}
              </Text>
            </div>
          )}

          {stats && (
            <div className="processing-stats">
              <Text type="secondary" size="small">
                Text: {stats.textPages} | OCR: {stats.ocrPages}
                {stats.failedPages > 0 && ` | Failed: ${stats.failedPages}`}
              </Text>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default PdfProcessingProgress;
